import { RegisterRecordExportDropDown as RegisterRecordExportDropDownBase } from '@framework/common-web/register-records/component/export/RegisterRecordExportDropDown.tsx';
import { type AlboConfigurazioneTipoDTO } from '@framework/common-web/register-records/frontoffice/api/schemas/alboConfigurazioneTipoDTO.ts';
import { type GetAlboRecordParams } from '@framework/common-web/register-records/frontoffice/api/schemas/getAlboRecordParams.ts';
import { FrontofficeExportRegisterRecordsFileButton } from './export/FrontofficeExportRegisterRecordsFileButton.tsx';

/** Props del dropdown export albi per il Frontoffice. */
interface IFrontofficeRegisterRecordExportDropDownProps {
  readonly registerRecordType: AlboConfigurazioneTipoDTO | null;
  readonly query: GetAlboRecordParams;
}

/** Wrapper FO del dropdown export albi. Inietta i flag FO e il bottone FO. */
export function FrontofficeRegisterRecordExportDropDown(
  props: IFrontofficeRegisterRecordExportDropDownProps,
) {
  return (
    <RegisterRecordExportDropDownBase
      {...props}
      csvExportFlagField="flExportCsvFo"
      pdfExportFlagField="flExportPdfFo"
      ExportButton={FrontofficeExportRegisterRecordsFileButton}
    />
  );
}
